import { OrgBaseInterface } from "../Shared/OrgBase.Interace";

export enum NotificationChannel {
  DESKTOP = "desktop",
  SMS = "sms",
  EMAIL = "email",
  SLACK = "slack"
}

/**
 * What happened to one staff notification (ENG-3373): `sent` left Swivl; `simulated` was built and
 * withheld by the Outbound Gate (`reason` says why); `blocked` = opted out; `no_destination` = the
 * member has no phone / email / subscription / Slack id for that channel; `not_configured` = the
 * org or server lacks the transport (no Twilio env, no Slack app).
 */
export interface NotificationOutcome {
  channel: NotificationChannel;
  outcome: "sent" | "simulated" | "blocked" | "no_destination" | "not_configured";
  /** The gate's reason (`flag_off`, `not_listed`, `opted_out`, …) or what was missing. */
  reason?: string;
  /** Where it went or would have gone: the phone, the email, the member id. */
  destination?: string;
}

export enum NotificationGroup {
  CONVERSATIONS = "conversations",
  TICKET_ASSIGNED = "ticketAssigned",
  TICKET_NOTES = "ticketNotes",
  TICKET_GROUP = "ticketGroup",
  TICKET_SUBSCRIBED = "ticketSubscribed"
}

export interface ChannelFlagsInterface {
  desktop: boolean;
  sms: boolean;
  email: boolean;
  slack: boolean;
}

export interface NotificationPreferencesInterface extends OrgBaseInterface {
  memberId: number;
  notificationEmail?: string;
  notificationPhone?: string;
  preferences: Record<NotificationGroup, ChannelFlagsInterface>;
  autoSubscribeGroupSlugs: string[];
}
